/* Header cart bag: always open the Ascendify side cart, never go to /cart (SOP 0c) */
if(!window.__wtpCartBag){window.__wtpCartBag=true;document.addEventListener('click',function(e){
  var a=e.target.closest&&e.target.closest('[data-np-cart]');if(!a)return;
  var drawer=document.querySelector('cart-drawer')||document.querySelector('cart-notification');
  if(drawer){e.preventDefault();if(typeof drawer.open==='function')drawer.open();else drawer.classList.add('active','is-open','open');
    var d=drawer.closest&&drawer.closest('details');if(d)d.open=true;}
});}
/* White Teeth Powder lander — document-scoped runtime for the modular PDP sections.
   Re-architected from the original <smile-pdp> custom element so the pillars can
   live in separate Shopify sections. Null-guarded throughout; adds to the
   Ascendify cart drawer in place (falls back to the cart page). */
(() => {
  if (window.__smileLander) return;
  window.__smileLander = true;

  const boot = () => {
    const $ = (s, r = document) => r.querySelector(s);
    const $$ = (s, r = document) => [...r.querySelectorAll(s)];
    const on = (el, ev, fn, opt) => el && el.addEventListener(ev, fn, opt);

    const cfgEl = $('[data-product-config]');
    if (!cfgEl) return;                                   // no offer config -> nothing to drive
    let config; try { config = JSON.parse(cfgEl.textContent); } catch (e) { return; }
    const packs = config.packs || [];
    const preview = false;                                // live theme is never preview
    const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
    const ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    const money = n => new Intl.NumberFormat(document.documentElement.lang || 'en-US',
      { style: 'currency', currency: config.currency || 'USD' }).format(n / 100);
    const available = p => preview || Boolean(p.variantId && p.available);

    let selected = null, busy = false;

    // ---- price / labels refresh ----
    const refresh = () => {
      packs.forEach(p => {
        const hasPrice = preview || Boolean(p.variantId);
        $$(`[data-unit="${p.count}"]`).forEach(e => e.textContent = hasPrice ? money(Math.round(p.price / p.count)) : '\u2014');
        $$(`[data-total="${p.count}"]`).forEach(e => e.textContent = hasPrice ? money(p.price) : '\u2014');
        $$(`[data-compare="${p.count}"]`).forEach(e => { e.textContent = money(p.compare); e.hidden = !(p.compare > p.price); });
        $$(`[data-saving="${p.count}"]`).forEach(e => e.textContent = p.compare > p.price ? `${Math.round((1 - p.price / p.compare) * 100)}% OFF` : '');
        $$(`[data-pack="${p.count}"]`).forEach(card => {
          const input = card.querySelector('input'); if (input) input.disabled = !available(p);
          const nm = card.querySelector('[data-pack-name]'); if (nm) nm.textContent = p.title;
          const sh = card.querySelector('[data-shipping]'); if (sh) sh.textContent = !available(p) ? 'Currently unavailable' : p.shipping ? `+${money(p.shipping)} shipping` : 'FREE shipping';
          if (p.free === 0) card.querySelectorAll('.sm-bottle>b').forEach(b => b.hidden = true);
        });
      });
      const entry = packs.filter(available).sort((a, b) => a.price - b.price)[0];
      $$('[data-entry-price]').forEach(e => e.textContent = entry ? money(entry.price) : 'Unavailable');
      $$('[data-entry-count]').forEach(e => e.textContent = entry ? `${entry.count * 30} smile sessions` : '');
      const st = $('[data-sticky-title]'); if (st) st.textContent = entry ? `${entry.count} ${entry.count === 1 ? 'bottle' : 'bottles'}` : 'Currently unavailable';
      const sd = $('[data-sticky-detail]'); if (sd) sd.textContent = entry ? `${entry.count * 30} smile sessions \u00b7 ${entry.shipping ? '+' + money(entry.shipping) + ' shipping' : 'Free shipping'}` : '';
      
    };

    const select = (count, update = true) => {
      selected = packs.find(p => p.count === count && available(p)) || null;
      $$('[data-pack]').forEach(c => {
        const yes = Number(c.dataset.pack) === selected?.count;
        c.classList.toggle('selected', yes);
        const input = c.querySelector('input'); if (input) input.checked = yes;
      });
      $$('[data-buy]').forEach(b => b.disabled = !selected);
      $$('[data-selected-price]').forEach(e => e.textContent = selected ? money(selected.price) : 'Unavailable');
      $$('[data-selection]').forEach(e => e.textContent = selected
        ? `${selected.count} ${selected.count === 1 ? 'bottle' : 'bottles'} \u00b7 ${selected.count * 30} smile sessions \u00b7 ${selected.shipping ? money(selected.shipping) + ' shipping' : 'Free shipping'}`
        : 'This set is currently unavailable.');
      if (update && selected?.variantId) {
        const u = new URL(location.href); u.searchParams.set('variant', selected.variantId); history.replaceState({}, '', u);
      }
    };

    $$('input[type=radio][data-pack-input], .sm-pack input[type=radio]').forEach(i => on(i, 'change', () => select(Number(i.value))));
    $$('[data-select]').forEach(b => on(b, 'click', () => select(Number(b.dataset.select))));

    // ---- facts / dialogs ----
    $$('[data-open-facts]').forEach(b => on(b, 'click', () => $('[data-facts]')?.showModal()));
    $$('[data-close]').forEach(b => on(b, 'click', () => b.closest('dialog')?.close()));
    $$('dialog').forEach(d => on(d, 'click', e => {
      if (e.target === d) { const r = d.getBoundingClientRect(); if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) d.close(); }
    }));

    // ---- gallery (+ inject authorized real-result pairs into position 2) ----
    const stage = $('.sm-stage'), thumbs = $('.sm-thumbs');
    let galleryOrder = [], galleryIndex = 0;
    const gallery = i => {
      const slides = $$('[data-slide]', stage); const n = slides.length; if (!n) return;
      galleryIndex = (i + n) % n;
      slides.forEach(e => e.hidden = Number(e.dataset.slide) !== galleryOrder[galleryIndex]);
      $$('[data-gallery]', thumbs).forEach(e => e.setAttribute('aria-pressed', String(Number(e.dataset.gallery) === galleryOrder[galleryIndex])));
    };
    if (stage && thumbs) {
      const second = $$('[data-slide]', stage)[1], secondThumb = $$('[data-gallery]', thumbs)[1];
      $$('[data-real-result]', stage).forEach(el => second ? stage.insertBefore(el, second) : stage.append(el));
      $$('[data-real-result]', thumbs).forEach(el => secondThumb ? thumbs.insertBefore(el, secondThumb) : thumbs.append(el));
      galleryOrder = $$('[data-slide]', stage).map(el => Number(el.dataset.slide));
      thumbs.style.setProperty('--gallery-count', $$('[data-slide]', stage).length);
      $$('[data-gallery]', thumbs).forEach(b => on(b, 'click', () => gallery(galleryOrder.indexOf(Number(b.dataset.gallery)))));
      $$('[data-gallery-step]').forEach(b => on(b, 'click', () => gallery(galleryIndex + Number(b.dataset.galleryStep))));
      const keys = e => {
        if (e.target.matches('input[type=range]')) return;
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(e.key)) return;
        e.preventDefault(); const count = $$('[data-slide]', stage).length;
        gallery(e.key === 'Home' ? 0 : e.key === 'End' ? count - 1 : galleryIndex + (e.key === 'ArrowRight' ? 1 : -1));
      };
      on(stage, 'keydown', keys); on(thumbs, 'keydown', keys);
    }

    // ---- initial selection ----
    refresh();
    const requested = new URL(location.href).searchParams.get('variant');
    const initial = packs.find(p => String(p.variantId) === requested && available(p)) || packs.find(p => p.count === 3 && available(p)) || packs.find(available);
    select(initial?.count, false);

    // ---- before/after proof slider ----
    $$('[data-proof-range]').forEach(range => on(range, 'input', () => range.closest('[data-proof-compare]')?.style.setProperty('--split', range.value + '%')));

    // ---- number counters ----
    const finishCounters = section => {
      cancelAnimationFrame(counterFrame); counterFrame = 0; section.classList.remove('is-counting');
      section.querySelectorAll('[data-count]').forEach(el => { const v = Number(el.dataset.count); el.textContent = el.dataset.money ? money(v) : String(v); });
    };
    let counterFrame = 0, countInView = false;
    const count = section => {
      finishCounters(section); if (reduced) return;
      const counters = [...section.querySelectorAll('[data-count]')], start = performance.now() + 180;
      counters.forEach(el => el.textContent = el.dataset.money ? money(0) : '0'); section.classList.add('is-counting');
      const tick = now => {
        let complete = true;
        counters.forEach((el, index) => {
          const progress = Math.max(0, Math.min(1, (now - start - index * 100) / 1800));
          const value = Math.round(Number(el.dataset.count) * progress * (2 - progress));
          el.textContent = el.dataset.money ? money(value) : String(value);
          if (progress < 1) complete = false;
        });
        if (complete) finishCounters(section); else counterFrame = requestAnimationFrame(tick);
      };
      counterFrame = requestAnimationFrame(tick);
    };
    const numbers = $('.sm-numbers');
    if (numbers) new IntersectionObserver(entries => entries.forEach(entry => {
      if (!entry.isIntersecting) { countInView = false; finishCounters(entry.target); return; }
      if (entry.intersectionRatio >= .45 && !countInView) { countInView = true; count(entry.target); }
    }), { threshold: [0, .45], rootMargin: '0px 0px -70px 0px' }).observe(numbers);

    // ---- three.js science scene (dynamic import; scroll-driven) ----
    const scene = $('[data-tooth-scene]');
    const scienceSection = scene?.closest('.sm-science');
    let tooth = null, lastSceneProgress = -1, loadingScene = false;
    const phase = p => {
      const stg = p < .27 ? 0 : p < .76 ? 1 : 2;
      const titles = ['The color you see.', 'Purple. Across the surface.', 'Less yellow. More smile.'];
      const copy = ['Yellow undertones can change how bright a smile looks.', 'Purple sits opposite yellow. The cleansing foam carries that optical effect around the teeth.', 'Opposite tones balance the appearance of yellow for a brighter-looking finish.'];
      const t = $('[data-phase-title]'); if (t) t.textContent = titles[stg];
      const c = $('[data-phase-copy]'); if (c) c.textContent = copy[stg];
      $$('[data-phase]').forEach((b, i) => b.setAttribute('aria-pressed', String(i === stg)));
    };
    const updateScene = () => {
      if (!tooth || !scienceSection) return;
      const r = scienceSection.getBoundingClientRect();
      const pin = $('.sm-medical-pin');
      const distance = scienceSection.offsetHeight - (pin ? pin.offsetHeight : 0);
      const p = reduced ? 1 : Math.max(0, Math.min(1, -r.top / Math.max(1, distance)));
      if (p !== lastSceneProgress) { lastSceneProgress = p; tooth.set(p); }
    };
    if (scene) {
      const sceneObserver = new IntersectionObserver(async entries => {
        if (!entries.some(e => e.isIntersecting) || loadingScene) return;
        loadingScene = true; sceneObserver.disconnect();
        try {
          const mod = await import(new URL(scene.dataset.engineUrl, document.baseURI).href);
          const t = await mod.createToothScene(scene, { reduced, onPhase: phase });
          tooth = t;
          $$('[data-phase]').forEach(b => on(b, 'click', () => {
            const p = Number(b.dataset.phase);
            if (reduced) { tooth.set(p); return; }
            const pin = $('.sm-medical-pin');
            const distance = scienceSection.offsetHeight - (pin ? pin.offsetHeight : 0);
            window.scrollTo({ top: scrollY + scienceSection.getBoundingClientRect().top + p * distance, behavior: 'smooth' });
          }));
          updateScene();
        } catch (error) {
          scene.classList.add('failed');
          $$('[data-phase]').forEach(b => b.disabled = true);
        }
      }, { rootMargin: '450px' });
      sceneObserver.observe(scene);
    }

    // ---- sticky bar (hidden while an offer or the science scene is on screen) ----
    const sticky = $('[data-sticky]');
    // Fallback CTA: hide whenever ANY buy/CTA button is on screen; show only when none + past fold + selected.
    const stickyCtas = sticky ? $$('[data-buy], [data-select], .sm-button').filter(el => !el.closest('[data-sticky]')) : [];
    const ctaOnScreen = new Set();
    const updateSticky = () => {
      if (!sticky) return;
      const aboveFold = window.scrollY < window.innerHeight * 0.5;
      sticky.hidden = !selected || aboveFold || ctaOnScreen.size > 0;
    };
    if (sticky) {
      const stickyIO = new IntersectionObserver(entries => {
        entries.forEach(e => { if (e.isIntersecting) ctaOnScreen.add(e.target); else ctaOnScreen.delete(e.target); });
        updateSticky();
      }, { threshold: 0 });
      stickyCtas.forEach(c => stickyIO.observe(c));
    }
    let stickyFrame = 0;
    const queue = () => { if (stickyFrame) return; stickyFrame = requestAnimationFrame(() => { stickyFrame = 0; updateSticky(); updateScene(); }); };
    on(window, 'scroll', queue, { passive: true }); on(window, 'resize', queue, { passive: true });
    updateSticky();

    // ---- Ascendify cart-drawer bridge ----
    function swapDrawer(dest, html) {
      if (!dest || !html) return;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('cart-drawer') || doc.getElementById('shopify-section-cart-drawer') || doc.querySelector('.shopify-section') || doc.body;
      const inner = fresh ? fresh.innerHTML : '';
      if (!inner || !inner.trim()) return;
      if (fresh.tagName && fresh.tagName.toLowerCase() === 'cart-drawer') [...fresh.attributes].forEach(a => { try { dest.setAttribute(a.name, a.value); } catch (e) {} });
      else dest.classList.remove('is-empty', 'empty', 'cart-empty', 'drawer--empty');
      dest.innerHTML = inner;
    }
    function swapBubble(html) {
      const dest = document.getElementById('cart-icon-bubble'); if (!dest || !html) return;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.getElementById('cart-icon-bubble') || doc.querySelector('.shopify-section') || doc.body;
      const inner = fresh ? fresh.innerHTML : ''; if (inner && inner.trim()) dest.innerHTML = inner;
    }
    const setCartCount = n => $$('[data-np-cart-count]').forEach(el => { el.textContent = n; el.hidden = !(Number(n) > 0); });
    $$('[data-np-cart]').forEach(a => on(a, 'click', e => {
      const drawer = document.querySelector('cart-drawer');
      if (drawer) { e.preventDefault(); if (typeof drawer.open === 'function') drawer.open(); else drawer.classList.add('active', 'is-open', 'open'); }
    }));

    // Keep the header badge in sync with ANY cart mutation (add/remove/qty), incl. theme drawer removals.
    const syncCartCount = async () => { try { const c = await (await fetch(ROOT + 'cart.js', { headers: { 'Accept': 'application/json' } })).json(); setCartCount(c.item_count); } catch (e) {} };
    if (!window.__wtpCartFetchPatched) {
      window.__wtpCartFetchPatched = true;
      const _fetch = window.fetch;
      window.fetch = function (...args) { let u = args[0]; u = (u && u.url) ? u.url : u; const ret = _fetch.apply(this, args); if (typeof u === 'string' && /\/cart\/(add|change|update|clear)(\.js)?/.test(u)) ret.then(() => setTimeout(() => document.dispatchEvent(new CustomEvent('wtp:cartsync')), 90)).catch(() => {}); return ret; };
    }
    document.addEventListener('wtp:cartsync', syncCartCount);
    ['cart:updated', 'cart:refresh', 'cart:change', 'ajaxCart:afterCartLoad'].forEach(ev => document.addEventListener(ev, syncCartCount));
    const _bubble = document.querySelector('#cart-icon-bubble, .cart-count-bubble, [data-cart-count], .cart-count');
    if (_bubble) new MutationObserver(syncCartCount).observe(_bubble, { childList: true, subtree: true, characterData: true });
    syncCartCount();

    const buy = async () => {
      const p = selected; if (!p || busy) return;
      busy = true;
      $$('[data-buy]').forEach(b => { b.disabled = true; b.setAttribute('aria-busy', 'true'); });
      $$('[data-cart-error]').forEach(e => e.hidden = true);
      try {
        const add = await fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: p.variantId, quantity: 1 }] }) });
        const result = await add.json();
        if (!add.ok) throw new Error(result.description || 'We could not add this set. Please try again.');
        const drawer = document.querySelector('cart-drawer');
        if (drawer) {
          const data = await (await fetch(ROOT + '?sections=cart-drawer,cart-icon-bubble')).json();
          swapDrawer(drawer, data['cart-drawer']); swapBubble(data['cart-icon-bubble']);
          try { const cj = await (await fetch(ROOT + 'cart.js')).json(); setCartCount(cj.item_count); } catch (e) {}
          if (typeof drawer.open === 'function') drawer.open(); else drawer.classList.add('active', 'is-open', 'open');
        } else {
          location.assign(ROOT + 'cart'); return;
        }
      } catch (error) {
        $$('[data-cart-error]').forEach(e => { e.textContent = error.message; e.hidden = false; });
      } finally {
        busy = false; $$('[data-buy]').forEach(b => { b.disabled = !selected; b.removeAttribute('aria-busy'); });
      }
    };
    $$('[data-buy]').forEach(b => on(b, 'click', buy));
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
